import React, { useState } from 'react';
import { Box } from '@wix/design-system';
import { CombinedValueControlProps } from '../../types';
import { CombinedControlConverter } from '../converters';

export const BlurControl: React.FC<CombinedValueControlProps> = ({
  getControl,
  combinedValue,
  onCombinedValueChange,
  mixMode,
}) => {
  const [Control] = useState(
    () => getControl('length', 'cssVariableType').Component,
  );
  const converter = new CombinedControlConverter('ShadowBlur');
  return (
    <Box direction="vertical">
      <Control
        minValue={0}
        maxValue={100}
        label={mixMode ? 'Blur (mixed values)' : 'Blur'} // TODO: add translations
        value={converter.importValue(combinedValue)}
        onChange={(updated) => {
          if (updated) {
            onCombinedValueChange(converter.exportValue(updated));
          }
        }}
      />
    </Box>
  );
};
